import React from 'react'
import { Translate } from 'react-redux-i18n'
import { Collapse } from '../../../../../../../common/collapse'
import { TableRiskScaleAndInterpretation } from './TableRiskScaleAndInterpretation'
import s from './index.module.scss'

const RiskScaleAndInterpretation = () => {
  const renderLeft = () => {
    return (
      <div className={s.titleTable}>
        <Translate value="riskScaleAndInterpretation.title" />
      </div>
    )
  }

  return (
    <Collapse
      isOpen={true}
      scrollIdToCollapse="companyAnalysis"
      renderLeft={renderLeft}
      renderRight={() => <></>}
      isToggleIconOnly
      iconStyle={{
        alignSelf: 'flex-start',
        marginRight: 4,
        marginLeft: 12,
        position: 'relative',
        top: 6,
      }}
      style={{
        backgroundColor: '#FFFFFF',
        cursor: 'default',
        padding: 6,
      }}
    >
      <TableRiskScaleAndInterpretation />
    </Collapse>
  )
}

export default RiskScaleAndInterpretation
